export enum NotificationState {
    ACTIVE = "ACTIVE",
    DISABLED = "DISABLED",
    NOT_SET = "NOT_SET"
}
